import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Box, Button, Flex, Stack, Title, useMantineTheme, } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import BoxContainer from "./BoxContainer";
import { BACKGROUND_COLOR } from "./theme/colors";
const MobileGate = ({ children }) => {
    const theme = useMantineTheme();
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs - 1}px)`);
    return (_jsxs(_Fragment, { children: [children, isMobile && (_jsx(Flex, { align: "center", sx: {
                    flex: 1,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: theme.fn.themeColor(BACKGROUND_COLOR.PRIMARY),
                    zIndex: 9999,
                }, children: _jsx(Box, { p: 40, children: _jsx(BoxContainer, { p: 40, w: "100%", children: _jsxs(Stack, { justify: "center", spacing: 32, children: [_jsx(Title, { order: 5, align: "center", children: "Visit us on desktop for the best experience" }), _jsx(Button, { component: "a", href: "https://highlight.xyz/", children: "Learn more" })] }) }) }) }))] }));
};
export default memo(MobileGate);
